@if (showVersionUpdate) {
  <div class="new-version d-flex justify-content-between align-items-center">
    <div class="new-version-text text-medium-bold">{{amdocsContentConstant?.newVersion.newVersionMessage}}
    </div>
    <button (click)="reload()" class="btn btn-medium secondary special-s2">Reload</button>
  </div>
}
